import React from 'react';

import {
    Modal,
    Select,
    InputNumber,
    Row,
    Col,
} from 'antd';

const { Option } = Select;

class WithdrawModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            activeCurrency: 'SGD',
            amount: 0,
            activePaymentMethodId:
            (this.props.paymentMethods["Paypal"] && this.props.paymentMethods["Paypal"].Id) || 
            (this.props.paymentMethods["Cash"] && this.props.paymentMethods["Cash"].Id),

			activeDepositToId:
            (this.props.paymentMethods["UOB Current"] && this.props.paymentMethods["UOB Current"].Id) ||
            (this.props.depositToAccounts["Inventory"] && this.props.depositToAccounts["Inventory"].Id)
        }
    }

    render() {

        const { paymentMethods, depositToAccounts } = this.props;

        return (
            <Modal
                centered
                onCancel={this.props.closeModal}
                onOk={() => this.props.handleWithdrawConfirm({
                    totalAmount: [{
                        currency: this.state.activeCurrency,
                        amount: this.state.amount,
                        activePaymentMethodId: this.state.activePaymentMethodId,
                        activeDepositToId: this.state.activeDepositToId
                    }]
                })}
                visible={this.props.visible}
            >
                <h2>How much do you want to Withdraw?</h2>
                <Row>
                    <Col span={6}>
                        Currency:
                    </Col>
                    <Col span={18}>
                        <Select defaultValue={this.state.activeCurrency} onChange={this.handleCurrencyChange}>
                                {this.props.currencies.map(_currency => (<Option value={_currency}>{_currency}</Option>))}
                            </Select>
                    </Col>
                </Row>
                <Row style={{paddingTop: 8}}>
                    <Col span={6}>
                        Amount:
                    </Col>
                    <Col span={18}>
                        <InputNumber 
                            min={0.0} 
                            step={0.01} 
                            value={this.state.amount}
                            formatter={value => `$ ${value}`}
                            onChange={this.handleAmountChange}
                        />
                    </Col>
                </Row>
                <Row style={{paddingTop: 8}}>
                    <Col span={6}>
                        Payment Method:
                    </Col>
                    <Col span={18}>
                        <Select
                            placeholder="Payment Method"
                            value={this.state.activePaymentMethodId}
                            onChange={(val) => this.setState({ activePaymentMethodId: val })}
                            style={{ width: 150 }}>
                            {Object.keys(paymentMethods).map(_key =>
                                <Option value={paymentMethods[_key].Id}>
                                    {paymentMethods[_key].Name}
                                </Option>
                            )}
                        </Select>
                    </Col>
                </Row>
                <Row style={{paddingTop: 8}}>
                    <Col span={6}>
                        Deposit to:
                    </Col>
                    <Col span={18}>
                        <Select
                            value={this.state.activeDepositToId}
                            placeholder="Deposit to"
                            onChange={(val) => this.setState({ activeDepositToId: val })}
                            style={{ width: 150 }}>
                            {Object.keys(depositToAccounts).map(_key =>
                                <Option value={depositToAccounts[_key].Id}>
                                    {depositToAccounts[_key].Name}
                                </Option>
                            )}
                        </Select>
                    </Col>
                </Row>
                
            </Modal>
        )
    }

    handleCurrencyChange = (value) => {
        console.log(value)
        this.setState({
            activeCurrency: value
        })
    }

    handleAmountChange = (value) => {
        console.log(value)
        this.setState({
            amount: value
        })
    }
}

export default WithdrawModal


// WEBPACK FOOTER //
// ./src/components/credit-overview/withdraw-modal.js